import React, { useState } from 'react';
import { categories } from '../data/categories';
import { registerProvider } from '../api/client';

const initialForm = {
  negocio: '',
  categoria: '',
  ciudad: '',
  estado: '',
  telefono: '',
  email: '',
  descripcion: '',
};

export default function Anunciate() {
  const [form, setForm] = useState(initialForm);
  const [sent, setSent] = useState(false);
  const [dashboardToken, setDashboardToken] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { dashboardToken: token } = await registerProvider({
        name: form.negocio,
        category: form.categoria,
        city: form.ciudad,
        state: form.estado,
        phone: form.telefono.replace(/\D/g, ''),
        email: form.email,
        description: form.descripcion,
      });
      setDashboardToken(token);
      setSent(true);
    } catch (err) {
      setError(err.message || 'No se pudo completar el registro. Intenta de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="section page-section anunciate-page">
      <div className="anunciate-hero">
        <div>
          <h1>Haz crecer tu negocio con MisXV.com.mx</h1>
          <p>
            Miles de familias buscan cada mes proveedores para la fiesta de XV años de su hija.
            Crea tu perfil, muestra tu galería de trabajos, recibe cotizaciones directas y
            gestiona tus reseñas desde un solo panel.
          </p>
          <ul className="benefits-list">
            <li>✔ Perfil de negocio con galería y paquetes</li>
            <li>✔ Recibe solicitudes de cotización directo a tu WhatsApp</li>
            <li>✔ Aparece en búsquedas por ciudad y categoría</li>
            <li>✔ Insignia de "Verificado" y reseñas de clientes reales</li>
            <li>✔ Planes destacados para mayor visibilidad</li>
          </ul>
        </div>
        <img src="https://picsum.photos/seed/anunciate/500/500" alt="Proveedores MisXV" />
      </div>

      <div className="anunciate-form-card">
        <h2>Regístrate como proveedor</h2>
        {sent ? (
          <div className="success-message">
            <p>
              ¡Gracias por registrarte! Tu perfil quedó <strong>pendiente de aprobación</strong>; nuestro
              equipo lo revisará en menos de 48 horas.
            </p>
            <p>
              Guarda este código: es tu <strong>llave de acceso</strong> para consultar las cotizaciones que
              te lleguen. No lo compartas y no podremos volver a mostrártelo.
            </p>
            <code className="dashboard-token">{dashboardToken}</code>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="form-grid">
            {error && <p className="error-message full-width">{error}</p>}
            <label>
              Nombre del negocio
              <input required value={form.negocio} onChange={handleChange('negocio')} />
            </label>
            <label>
              Categoría
              <select required value={form.categoria} onChange={handleChange('categoria')}>
                <option value="">Selecciona una categoría</option>
                {categories.map((c) => <option value={c.slug} key={c.slug}>{c.name}</option>)}
              </select>
            </label>
            <label>
              Ciudad
              <input required value={form.ciudad} onChange={handleChange('ciudad')} />
            </label>
            <label>
              Estado
              <input required value={form.estado} onChange={handleChange('estado')} />
            </label>
            <label>
              Teléfono / WhatsApp
              <input required type="tel" value={form.telefono} onChange={handleChange('telefono')} />
            </label>
            <label>
              Correo electrónico
              <input required type="email" value={form.email} onChange={handleChange('email')} />
            </label>
            <label className="full-width">
              Cuéntanos sobre tu negocio
              <textarea rows={4} required minLength={10} value={form.descripcion} onChange={handleChange('descripcion')} />
            </label>
            <button type="submit" className="btn btn-primary full-width" disabled={submitting}>
              {submitting ? 'Enviando...' : 'Crear mi perfil de proveedor'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
